import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core';
import { Button } from '@roc/ui';
import { FC } from 'react';

interface ConfirmRegenerateLinkModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmRegenerateLinkModal: FC<ConfirmRegenerateLinkModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Create Borrower Identity Verification</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to create a link for Borrower Identity Verification?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose} testId="cancelRegenerateLink">
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={onConfirm} testId="confirmRegenerateLink">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};